import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const ExploreButton = ({ path }) => (
  <Link
    className="nav-btn"
    to="/explore"
    state={path}
  >
    <span className="btn btn-sm m-1 flex-fill ">Explore</span>
  </Link>
);

export default connect()(ExploreButton);
